import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { GatewayFirmwareUpdateStatus } from '@vi-iot/client/index';

export namespace GatewayFirmwareUpdateActions {
  export enum Type {
    UPDATE_IN_PROGRESS = '[GATEWAY FIRMWARE UPDATE ACTIONS] Update in progress',
    SET_STATUS = '[GATEWAY FIRMWARE UPDATE ACTIONS] Setting status',
  }

  export const GatewayFirmwareUpdateTriggerActions = createActionGroup({
    source: 'GATEWAY FIRMWARE UPDATE ACTIONS',
    events: {
      'Installation process start': props<{ installationId: number; gatewaySerial: string }>(),
      'Installation process success': emptyProps(),
      'Installation process error ': props<{ err: any }>(),
    },
  });

  export const updateInProgress = createAction(Type.UPDATE_IN_PROGRESS);

  export const setStatus = createAction(
    Type.SET_STATUS,
    props<{ updatedStatus: GatewayFirmwareUpdateStatus }>()
  );
}
